import { render, staticRenderFns } from "./HomePage5.vue?vue&type=template&id=9706762c&scoped=true&"
import script from "./HomePage5.vue?vue&type=script&lang=js&"
export * from "./HomePage5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706762c",
  null
  
)

export default component.exports